<template>
  <div v-loading="loading" element-loading-text="加载中">
    <el-row>
      <el-col :span="24">
        <div id="charts-box-copy-lpie-census"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import echarts from "echarts";
import { API__code, API_control } from "../../../api/index.js";
export default {
  props:['userGuishuPie'],
  data() {
    return {
      chartsXAxis: [],
      //折线图数据
      chartsData: [],
      loading:true,
      chartPie:[],
      token:'',
      checkCode:'',
      otherList:[],
      numRecord:0,
    };
  },
  created() {},
  mounted() {
  },
  watch:{
    'userGuishuPie':function(val){
      this.adminModulePointPie();
    }
  },
  methods: {
    adminModulePointPie(val) {
      
      var list = [];
      var data = this.userGuishuPie;
      var num = 0;
      for(var p in data){//计算出总记录数
        num = num + data[p].value;
      }

      this.numRecord = num;
      // var big = [];
      // var little = [];
      // for(var k in data){//百分比小于2%归类于其他
      //   var percent = (data[k].value/num)*100;
      //   let param={
      //     name:JSON.parse(data[k].name).value,
      //     value:data[k].value
      //   }
      //   if(percent >= 2){
      //     big.push(param);
      //   }else{
      //     little.push(param);
      //   };
      // }

      // this.otherList = little;

      // var sumLittle = 0;
      // for(var c in little){//累计其他总数
      //   sumLittle = sumLittle + little[c].value;
      // }

      // big.push({name:'其他',value:sumLittle})
      
      this.chartPie = data;
      
      this.initCharts();
      this.loading = false;
        
    },
    initCharts() {
      var _this = this;
      var charts = null;

      let allcount=0
      let selected={};
      for(let i=0;i<this.chartPie.length;i++){
        allcount+=this.chartPie[i].value
      }

      for(let i=0;i<this.chartPie.length;i++){
        let name=this.chartPie[i].name
        selected[name]=this.chartPie[i].value/allcount>0.05;
      }
      charts = echarts.init(document.getElementById("charts-box-copy-lpie-census"));
      charts.showLoading(); //显示等待框
      charts.setOption({
        title: {
          text: "用户手机号归属地统计",
          top: "top",
          left: "left",
          textStyle: {
            color: "#596471",
            fontSize: 17,
            fontWeight: 100,
          },
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b} : {c} ({d}%)",
          
          // formatter: function (params) {
          //   if(params.data.name == "其他"){
          //     var data = _this.otherList;
          //     var num = _this.numRecord;
          //     var str = '';
          //     for(var p in data){
          //       if(str != ''){
          //         str = str + '</br>'
          //       }
          //       str = str + data[p].name+' :  '+data[p].value+'    ('+parseFloat((data[p].value/num)*100).toFixed(2)+'%)'
          //     }
          //     return str
          //   }else{
          //     return params.data.name+' :'+params.data.value+'('+params.percent+'%)'
          //   }
          // },
        },
        legend:{
          type: 'scroll', // 数据过多时，分页显示
          orient: 'vertical',
		        right: 0,
		        top: 20,
		        bottom: 0,
		        selected:selected  //这里默认显示数组中前六个，如果不设置，则所有的数据都会显示在图表上
		    },
        series: [
          {
            name: "用户手机号归属地统计",
            type: "pie",
            radius: "20%",
            center: ["30%", "55%"],
            data: this.chartPie,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
                show: true,
                color:'black',
                fontSize:10,
                formatter: function (params) {
                  return params.name+": "+params.value;
                },
            },
            labelLine:{
              normal:{
                length:4,
                length:12
              }
            }
          },
        ],
        color:['#FF6383','#FFCB48',
        '#5C89FF','#7C6AF2','#C95FF2','#52c41a'
        ,'#13c2c2','#c41d7f','#a0d911','#f5222d'
        ,'#096dd9','#a0d911','#2f54eb','#fa541c','#fadb14','#13c2c2','#2f54eb']
      });
      charts.hideLoading(); //隐藏等待框
      //this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
#charts-box-copy-lpie-census {
  width: 100%;
  height: 336px;
  background-color: white;
  border-radius: 2px;
}

</style>



// WEBPACK FOOTER //
// census.vue?f0d2f6de